import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";
import AdminDashboard from "@/pages/AdminDashboard";
import WheelPage from "@/pages/WheelPage";
import ForumPage from "@/pages/ForumPage";
import ForumCreditsPage from "@/pages/ForumCreditsPage";
import ForumAskPage from "@/pages/ForumAskPage";
import ForumMyQuestionsPage from "@/pages/ForumMyQuestionsPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import { InAppBrowserDetector } from "@/components/InAppBrowserDetector";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <InAppBrowserDetector />
      <Toaster />
      <Sonner />
      <HashRouter>
<Routes>
          <Route path={ROUTE_PATHS.HOME} element={<Home />} />
          <Route path={ROUTE_PATHS.ADMIN} element={<AdminDashboard />} />
          <Route path="/wheel" element={<WheelPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path={ROUTE_PATHS.FORUM} element={<ForumPage />} />
          <Route path={ROUTE_PATHS.FORUM_CREDITS} element={<ForumCreditsPage />} />
          <Route path={ROUTE_PATHS.FORUM_ASK} element={<ForumAskPage />} />
          <Route path={ROUTE_PATHS.FORUM_MY_QUESTIONS} element={<ForumMyQuestionsPage />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;